import { AuthenticationException } from './authentication-exception';

export class RoleNotFoundException extends AuthenticationException {}
